import {
  CheckboxSelectionCallbackParams,
  ICellRendererParams,
} from "ag-grid-community";
import { DocumentsComponent } from "./documents.component";

export const cosignDocumentsColumns = (component: DocumentsComponent) => ({
  columnDefinitions: [
    {
      maxWidth: 60,
      suppressMenu: true,
      headerClass: "text-xs",
      field: "selection",
      headerName: "",
      headerCheckboxSelection: true,
      checkboxSelection: (params: CheckboxSelectionCallbackParams<any>) => {
        return !!params.data && params.data.isSelectedItem !== true;
      },
      showDisabledCheckboxes: true,
      hide: !component.canAccess,
    },
    {
      suppressMenu: true,
      headerName: "Activity Date",
      field: "activitydate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return params.value;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Patient Name",
      field: "patientname",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Discipline",
      field: "disciplinename",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Doc Type",
      field: "doctype",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "Start Date",
      field: "startdate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerName: "End Date",
      field: "enddate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      headerName: "Assigned Date",
      suppressMenu: true,
      field: "assigneddate",
      sortable: true,
      headerClass: "text-xs",
      cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return `<span title="${params.value}"> ${params.value} <span>`;
        }
        return "—";
      },
    },
    {
      suppressMenu: true,
      headerClass: "text-xs",
      field: "selection",
      headerName: "View",
      cellRenderer: (params: any) => {
        ``;
        const link = document.createElement("a");
        link.innerText = "View";
        link.style.cursor = "pointer";
        link.addEventListener("click", (event) => {
          component.navigateToDocumentsPage(params);
        });
        return link;
      },
    },
  ],
});
